/**
 * 检查的类型
 */

import { store } from "@/main";
import Vue from "vue";
import { GETTER_CURRENT_INS_USER_INFO } from "@/store/constants/ins_user_info_types";
import {
  Offer,
  OfferKind,
  OfferWay,
  SkuClickCategory
} from "@/services/offer/offer_handle";
import * as cg_user_types from "@/store/constants/cg_user_types";
import * as ins_media_types from "@/store/constants/ins_media_types";
import * as types from "@/store/constants/ins_user_info_types";
import * as index_types from "@/store/constants/index_types";

import * as ins_user_info_types from "@/store/constants/ins_user_info_types";
import Loading from "@/plugins/toast/loading";
import paymentCheckModule from "@/services/payment/payment_check/index";
import { setAccountPublic } from "@/api/ins_api_new/apis/ins_user";
import { enableComments } from "@/api/ins_api_new/apis/ins_media";
// 是否有用户
export const hasUser = () => {
  const currentUserInfo = store.getters[GETTER_CURRENT_INS_USER_INFO];
  return !!currentUserInfo;
};

// 是否缺少金币
export const lackCoins = (offer: Offer) => {
  // coins购买类型的offer
  const isCoinsWay = offer.way === OfferWay.coin;
  // 用户coins数量
  const user_coin = store.getters[cg_user_types.GETTER_COINS];
  // 订单coins数量
  const offer_coins = offer.coins ? offer.coins : 0;
  return isCoinsWay && user_coin < offer_coins;
};

// 是否是没有video的情况下买view
export const buyViewWithoutVideo = (offer: Offer) => {
  // 是否是view类型
  const isView = offer.kind === OfferKind.view;
  // 当前用户的Post
  const postInfo = store.getters[ins_media_types.GETTER_CURRENT_POST_INFO];
  // 判断当前的post是否是video
  const is_video = postInfo && postInfo.is_video;
  return isView && !is_video;
};

// 是否是无post的情况下买like或者comment
export const buyLikeOrCommentWithoutPost = (offer: Offer) => {
  const isLikeOrComment =
    offer.kind.includes(OfferKind.like) ||
    offer.kind.includes(OfferKind.comment);
  const postInfo = store.getters[ins_media_types.GETTER_CURRENT_POST_INFO];
  console.log("postInfo", postInfo);
  return isLikeOrComment && !postInfo;
};

// comment是否可以评论
export const isPostCommentDisabled = (offer: Offer) => {
  const isComment = offer.kind.includes(OfferKind.comment);
  const postInfo = store.getters[ins_media_types.GETTER_CURRENT_POST_INFO];
  const comments_disabled = postInfo && postInfo.comments_disabled;
  const userInfo = store.getters[types.GETTER_CURRENT_INS_USER_INFO];
  return {
    // comments_disabled: false,
    comments_disabled: isComment && comments_disabled,
    user_type: userInfo.user_type
  };
};

export const isLargePurchase = (offer: Offer) => {
  const isCoinsWay = offer.way === OfferWay.coin;
  const offer_coins = offer.coins ? offer.coins : 0;
  return isCoinsWay && offer_coins >= 2000;
};

export const isPrivateUser = () => {
  const currentUserInfo = store.getters[GETTER_CURRENT_INS_USER_INFO];
  return currentUserInfo.ins_user_info.is_private;
};

export const changeInsUserPrivateAccount = async () => {
  try {
    const currentUserId = store.getters[index_types.GETTER_CURRENT_USER_ID];
    const accountResult: any = await setAccountPublic(currentUserId);
    const { status } = accountResult;
    if (status === "ok") {
      // 获取最新的ins信息
      await store.dispatch(
        ins_user_info_types.REFRESH_ONE_INS_USER_INFO,
        currentUserId
      );
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};

export const privateUserConfirm = async (params: any) => {
  if (params.type === "login") {
    //  将隐私账号变成非隐私账号，并且购买;
    try {
      Loading.show();
      const accountResult: any = await changeInsUserPrivateAccount();
      Loading.hide();
      if (accountResult) {
        setTimeout(() => {
          paymentCheckModule.get().next();
        }, 0);
      }
    } catch (error) {
      Loading.hide();
    }
  }
};

export const enableMediaComment = async () => {
  try {
    Loading.show();
    const current_user_id = store.getters[index_types.GETTER_CURRENT_USER_ID];
    const postInfo = store.getters[ins_media_types.GETTER_CURRENT_POST_INFO];
    const { id } = postInfo;
    const enableMediaCommentsResult: any = await enableComments(
      id,
      current_user_id
    );
    const { status } = enableMediaCommentsResult;
    if (status === "ok") {
      await store.dispatch(ins_media_types.UPDATE_ONE_INS_POST_INFO, {
        user_id: current_user_id,
        media_id: id
      });
      Loading.hide();
      setTimeout(() => {
        paymentCheckModule.get().next();
      }, 0);
    } else {
      Loading.hide();
      Vue.prototype.$_Toast.show({
        duration: 4000,
        text: `Sorry,The request time out,Please try again later!`
      });
    }
  } catch (error) {
    Loading.hide();
    Vue.prototype.$_Toast.show({
      duration: 4000,
      text: `Opps,unexpected error.`
    });
  }
};
